import {Injectable, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Http, Response, Headers, RequestOptions} from '@angular/http';
import {Router} from '@angular/router';
const json = require("json!./../../../../../resources/properties.json");

@Injectable()
export class VerifyEmailService {
  private token: string;
  private _verifyEmailUrl = '/emailData/verifyEmail';
  private serverURL: string;

  constructor(private http: Http, private router:Router) {
      this.serverURL = json.api_url;
  }

  verifyEmail(emailKey: string) {
      var authHeader = new Headers({
          'Content-Type': 'application/x-www-form-urlencoded'
      });
      let options = new RequestOptions({ headers: authHeader, body: "" });
      return this.http.get(this.serverURL + this._verifyEmailUrl+"/"+emailKey, options)
      .toPromise()
      .then(res => { 
        console.log(res);
            localStorage.setItem('token', JSON.parse(res.text()).token);
            //localStorage.setItem('token', JSON.parse(res.text()).id_user);
            this.router.navigate(['/superuser', 'start']);
      }, this.handleError);
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
  }

  
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/start/verify_email/verify-email.service.ts
 **/